import { Guid } from '../model/guid';
import { StudentStore } from '../models/Store';
import { MenuStartingMessageReducerState } from '../reducers/menuStartingMessageReducer';
import { ContentItemType, ensureItemIsContentItemType, ensureNotUndefined, isSection, Item } from '@ael/core-api';
import { OrderedMap } from 'immutable';
import { createSelector } from 'reselect';

const getCurrentQuizContentItemId: (store: StudentStore) => Guid | null = (state) =>
  state.currentQuiz.currentContentItem;
const getCurrentHotspotTabId: (store: StudentStore) => Guid | null = (state) => state.currentHotspot.selectedTabId;
const getCurrentSequencedFlowContentItemId: (store: StudentStore) => Guid | null = (state) =>
  state.currentSequencedFlowPosition.current;
const getCurrentResourceId: (store: StudentStore) => Guid | null = (state) => state.currentResource;
const getStartingMessageState: (store: StudentStore) => MenuStartingMessageReducerState = (state) =>
  state.menuStartingMessage;
const getItems: (store: StudentStore) => OrderedMap<Guid, Item> = (state: StudentStore) => state.items;

export const getCurrentContentItem: (store: StudentStore) => ContentItemType | null = createSelector(
  [
    getCurrentQuizContentItemId,
    getCurrentHotspotTabId,
    getCurrentSequencedFlowContentItemId,
    getCurrentResourceId,
    getStartingMessageState,
    getItems,
  ],
  (
    currentQuizContentItemId: Guid | null,
    currentHotspotTabId: Guid | null,
    currentSequencedFlowContentItemId: Guid | null,
    currentResourceId: Guid | null,
    startingMessageState: MenuStartingMessageReducerState,
    items: OrderedMap<Guid, Item>
  ) => {
    const currentContentItemId =
      startingMessageState.startingMessageId && !startingMessageState.dismissed
        ? startingMessageState.startingMessageId
        : currentQuizContentItemId ||
          currentHotspotTabId ||
          currentSequencedFlowContentItemId ||
          currentResourceId ||
          null;

    if (currentContentItemId) {
      const item = items.get(currentContentItemId);
      ensureNotUndefined(item);
      // Workaround - section is not a content item type, but it is saved to the `currentSequencedFlowPosition.current`.
      // We do not want to throw an error in this case, so we return null.
      if (isSection(item)) {
        return null;
      }
      ensureItemIsContentItemType(item);
      return item;
    }
    return null;
  }
);
